module.exports = __webpack_public_path__ + "img/0027.db91a03b.jpg";